export default "__VITE_ASSET__B5VRQ9Kd__"